<template>
	<div style="float: right">
    <div v-b-modal.manualModal class="button button-menu fake-button"><i class="fas fa-question" title="Help & Info"></i></div>

    <b-modal id="manualModal" :title="translations.Manual" size="xl">
      <div class="embed-responsive" style="height: 55vw">
        <iframe   
            :src="manualURL"
            width="100%"
            height="100%"
            class="embed-responsive-item"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              class="float-right"
              @click="$bvModal.hide('manualModal')"
            >
              {{translations.Close}}
            </b-button>
          </div>
        </template>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios"
export default {
  props: {
    manualURL: {
      type: String
    },
    translations: {
      type: Object
    }
  }
}
</script>

